import { Route } from '@angular/router';
import { LineSelectionComponent } from '@features/activity-types/change-phone-number/line-selection/line-selection.component';
import { FinalizeOrderComponent } from '@features/shopping/finalize-order/finalize-order.component';
import { ReviewComponent } from '@features/shopping/review/review.component';

export const change_phone_number_routes: Route[] = [
  {
    path: 'line-selection',
    component: LineSelectionComponent,
    title: 'Select Line',
    data: { order_type_id: 16 }
  },
  {
    path: 'finalize-order',
    component: FinalizeOrderComponent,
    title: 'Finalize Your Order',
    data: { order_type_id: 16 }
  },
  {
    path: 'review/:id',
    component: ReviewComponent,
    title: 'Review Your Order',
    data: { order_type_id: 16 }
  },
  {
    path: '',
    redirectTo: 'line-selection',
    pathMatch: 'full'
  }
];
